"use strict";
exports.__esModule = true;
exports.createReqRes = void 0;
var JSONCodec_1 = require("../packages/codecs/JSONCodec");
function createReqRes(name, input, output) {
    return {
        name: name,
        codecs: {
            req: new JSONCodec_1.JSONCodec(name + "-req", input),
            res: new JSONCodec_1.JSONCodec(name + "-res", output)
        }
    };
}
exports.createReqRes = createReqRes;
//# sourceMappingURL=createReqRes.js.map